export default __webpack_public_path__ + "static/media/background-register.ced14b32.webp";